export default __webpack_public_path__ + "static/media/Banner-L-LVT.62e76e22.jpg";